/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Object Pages 

import React from "react";
import GenericResourceTablePage from "../../../clientShared/components/pages/GenericResourceTablePage";
import {RESOURCE_ICONS_DICT} from "../../constants/serviceAndResourceIcons";
import {
	RESOURCE_TYPE_USER_ACCOUNT,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE,
	RESOURCE_TYPE_USER_HISTORY_ENTRY,
	RESOURCE_TYPE_BALANCE_CHANGE_LOG,
	RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA,
	RESOURCE_TYPE_USER_ACCOUNT_SETTINGS,
	RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST,
	RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION,
	RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING,
	RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS,
	RESOURCE_TYPE_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_PASSWORD,
	RESOURCE_TYPE_EXPIRED_PASSWORD,
	RESOURCE_TYPE_PASSWORD_RESET,
	RESOURCE_TYPE_DEPOSIT,
	RESOURCE_TYPE_DEPOSIT_INVITE,
	RESOURCE_TYPE_DEPOSIT_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_INTEREST,
	RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY,
	RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_USER_STATS,
	RESOURCE_TYPE_DEPOSIT_BANK_MAPPING,
	RESOURCE_TYPE_DEPOSITS_BULK_IMPORT,
	RESOURCE_TYPE_DEPOSIT_INTEREST_LOG,
	RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS,
	RESOURCE_TYPE_PMC_REPORT_TIMETABLE,
	RESOURCE_TYPE_DEPOSIT_GROUP,
	RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_USER_GROUP,
	RESOURCE_TYPE_PROPERTY_GROUP,
	RESOURCE_TYPE_PROPERTY_USER_GROUP,
	RESOURCE_TYPE_DISPUTE,
	RESOURCE_TYPE_DISPUTE_SPLIT,
	RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST,
	RESOURCE_TYPE_PROPERTY,
	RESOURCE_TYPE_PROPERTY_ADDRESS,
	RESOURCE_TYPE_COMPLIANCE,
	RESOURCE_TYPE_COMPLIANCE_RULE,
	RESOURCE_TYPE_COMPLIANCE_HISTORY,
	RESOURCE_TYPE_EMAIL_TEMPLATE,
	RESOURCE_TYPE_EMAIL_VERIFICATION,
	RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD,
	RESOURCE_TYPE_EMAIL_EVENT,
	RESOURCE_TYPE_SENT_EMAIL,
	RESOURCE_TYPE_MAILBOX,
	RESOURCE_TYPE_MAILBOX_META_DATA,
	RESOURCE_TYPE_MAILBOX_MESSAGE,
	RESOURCE_TYPE_PERMISSION_ENTRY,
	RESOURCE_TYPE_PERMISSION_LOG_ENTRY,
	RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS,
	RESOURCE_TYPE_RESOURCE_PERMISSIONS,
	RESOURCE_TYPE_ORGANIZATION,
	RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE,
	RESOURCE_TYPE_INVOICE,
	RESOURCE_TYPE_INVOICE_ITEM,
	RESOURCE_TYPE_PAYMENT_REQUEST,
	RESOURCE_TYPE_STRIPE_PAYMENT_LOG,
	RESOURCE_TYPE_USER_WITHDRAW,
	RESOURCE_TYPE_PRIORITY_ACH_PAYMENT,
	RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT,
	RESOURCE_TYPE_LOAN_APPLICATION,
	RESOURCE_TYPE_LOAN_SYSTEM_INFO,
	RESOURCE_TYPE_LOAN,
	RESOURCE_TYPE_LOAN_HISTORY,
	RESOURCE_TYPE_LOAN_PAYMENT_LOG,
	RESOURCE_TYPE_STRIPE_WEBHOOK_LOG,
	RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO,
	RESOURCE_TYPE_SEZZLE_ORDER,
	RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT,
	RESOURCE_TYPE_BANK_ACCOUNT,
	RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE,
	RESOURCE_TYPE_BANK_ACCOUNT_INTEREST,
	RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD,
	RESOURCE_TYPE_BANK_TRANSFER,
	RESOURCE_TYPE_BULK_FUNDS_TRANSFER,
	RESOURCE_TYPE_FUNDS_LOCK,
	RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG,
	RESOURCE_TYPE_RELEASED_FUNDS_LOCK,
	RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER,
	RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG,
	RESOURCE_TYPE_EVENT,
	RESOURCE_TYPE_EVENT_HOOK,
	RESOURCE_TYPE_NOTIFICATION,
	RESOURCE_TYPE_ACTION_ITEM,
	RESOURCE_TYPE_UPDATE_LOG_ENTRY,
	RESOURCE_TYPE_STORAGE_FILE,
	RESOURCE_TYPE_ATTACHED_STORAGE_FILES,
	RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY,
	RESOURCE_TYPE_SNAPSHOT,
	RESOURCE_TYPE_IP_ADDRESS,
	RESOURCE_TYPE_KNOWN_IP_ADDRESS,
	RESOURCE_TYPE_USER_AGENT,
	RESOURCE_TYPE_KNOWN_USER_AGENT,
	RESOURCE_TYPE_SYSTEM_STATS,
	RESOURCE_TYPE_RESOURCE_NOTE,
	RESOURCE_TYPE_DEPOSIFY_TAG,
	RESOURCE_TYPE_PERMANENT_LINK,
	RESOURCE_TYPE_ONLINE_USER,
	RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS,
	RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS,
	RESOURCE_TYPE_YARDI_VOYAGER_PET,
	RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_PHONE,
	RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR,
	RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY,
	RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS
} from "../../constants/resourceTypeConstants";
import {
	UserAccountsTable,
	UserAccountBalancesTable,
	UserAccountBalanceSourcesTable,
	UserHistoryEntriesTable,
	BalanceChangeLogsTable,
	InternationalBankAccountsTable,
	USDomesticBankAccountsTable,
	UserBankAccountDeltasTable,
	UserAccountSettingsTable,
	AdminGhostUserAccountsTable,
	UserAccountFinalizationsTable,
	ThirdPartyUserAccountMappingsTable,
	PreviousEmailAddressesTable,
	PendingEmailChangesTable,
	ArchivedPendingEmailChangesTable,
	PasswordsTable,
	ExpiredPasswordsTable,
	PasswordResetsTable,
	DepositsTable,
	DepositInvitesTable,
	DepositAdjustmentsTable,
	DepositInterestsTable,
	DepositHistoryEntriesTable,
	DepositCloseRequestsTable,
	DepositUserStatsTable,
	DepositBankMappingsTable,
	DepositBulkImportsTable,
	DepositInterestLogsTable,
	ArchivedDepositCloseRequestsTable,
	DepositWithheldFundsTable,
	PmcReportTimetablesTable,
	DepositGroupsTable,
	DepositPostCloseAdjustmentsTable,
	DepositUserGroupsTable,
	PropertyGroupsTable,
	PropertyUserGroupsTable,
	DisputesTable,
	DisputeSplitsTable,
	DisputeInterventionRequestsTable,
	PropertiesTable,
	PropertyAddressesTable,
	CompliancesTable,
	ComplianceRuleTable,
	ComplianceHistoriesTable,
	EmailTemplatesTable,
	EmailVerificationsTable,
	EmailVerificationRecordsTable,
	EmailEventsTable,
	SentEmailsTable,
	MailboxesTable,
	MailboxMetaDataTable,
	MailboxMessagesTable,
	PermissionEntriesTable,
	PermissionLogEntriesTable,
	PermissionsOrganizationSettingsTable,
	ResourcePermissionsTable,
	OrganizationsTable,
	OrganizationResourcePermissionRulesTable,
	InvoicesTable,
	InvoiceItemsTable,
	PaymentRequestsTable,
	StripePaymentLogsTable,
	UserWithdrawsTable,
	PriorityAchPaymentsTable,
	PriorityAchRecurringPaymentsTable,
	LoanApplicationsTable,
	LoanSystemInfosTable,
	LoansTable,
	HistoryEntriesTable,
	LoanPaymentLogsTable,
	LogEntriesTable,
	InfoTable,
	SezzleOrdersTable,
	SezzleWebhookEventsTable,
	BankAccountsTable,
	BankAccountHistoricalInterestRatesTable,
	BankAccountInterestsTable,
	BankAccountBalanceRecordsTable,
	BankTransfersTable,
	BulkFundsTransfersTable,
	FundsLocksTable,
	FundsLockReleaseLogsTable,
	ReleasedFundsLocksTable,
	BalanceSourceTransfersTable,
	CreditUserAccountLogsTable,
	EventsTable,
	EventHooksTable,
	NotificationsTable,
	ActionItemsTable,
	UpdateLogsTable,
	StorageFilesTable,
	AttachedStorageFilesTable,
	SystemHistoryEntriesTable,
	SnapshotsTable,
	IpAddressesTable,
	KnownIpAddressesTable,
	UserAgentsTable,
	KnownUserAgentsTable,
	SystemStatsTable,
	ResourceNoteTable,
	DeposifyTagsTable,
	LinksTable,
	OnlineUsersTable,
	FrontendGeneralSettingsTable,
	YardiScreeningWorksProXmlTable,
	YardiVoyagerXmlTable,
	YardiVoyagerTransactionsTable,
	YardiVoyagerResidentsTable,
	YardiVoyagerResidentCustomColumnsTable,
	YardiVoyagerPropertyUnitsTable,
	YardiVoyagerPropertiesTable,
	YardiVoyagerPmcServiceInterfaceVersionsTable,
	YardiVoyagerPmcsTable,
	YardiVoyagerPmcCredentialsTable,
	YardiVoyagerPetsTable,
	YardiVoyagerIlsGuestCardEventsTable,
	YardiVoyagerChargesTable,
	YardiVoyagerChargeCodesTable,
	YardiVoyagerDepositCreateIntentsTable,
	YardiVoyagerDepositCloseIntentsTable,
	YardiVoyagerDepositWithholdIntentsTable,
	YardiVoyagerEventsTable,
	YardiVoyagerFlexDepositIntentsTable,
	YardiVoyagerPhonesTable,
	YardiVoyagerOtherOccupantsTable,
	YardiVoyagerPmcCustomColumnSettingsTable,
	YardiVoyagerPmcStatsTable,
	YardiVoyagerPmcStatsCollectorsTable,
	YardiVoyagerActiveScanLogEntriesTable,
	YardiVoyagerSystemSettingsTable
} from "../tables/allObjectTables";



export function UserAccountPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_USER_ACCOUNT}
			displayComp={UserAccountsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_USER_ACCOUNT]}
			displayName={'User Account'}
		/>
	);
}

export function UserAccountBalancePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_BALANCE}
			displayComp={UserAccountBalancesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_USER_ACCOUNT_BALANCE]}
			displayName={'User Account Balance'}
		/>
	);
}

export function UserAccountBalanceSourcePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE}
			displayComp={UserAccountBalanceSourcesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE]}
			displayName={'User Account Balance Source'}
		/>
	);
}

export function UserHistoryEntryPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_USER_HISTORY_ENTRY}
			displayComp={UserHistoryEntriesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_USER_HISTORY_ENTRY]}
			displayName={'User History Entry'}
		/>
	);
}

export function BalanceChangeLogPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_BALANCE_CHANGE_LOG}
			displayComp={BalanceChangeLogsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_BALANCE_CHANGE_LOG]}
			displayName={'Balance Change Log'}
		/>
	);
}

export function InternationalUserBankAccountPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT}
			displayComp={InternationalBankAccountsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT]}
			displayName={'International User Bank Account'}
		/>
	);
}

export function USDomesticUserBankAccountPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT}
			displayComp={USDomesticBankAccountsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT]}
			displayName={'US Domestic User Bank Account'}
		/>
	);
}

export function UserBankAccountDeltaPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA}
			displayComp={UserBankAccountDeltasTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA]}
			displayName={'User Bank Account Delta'}
		/>
	);
}

export function UserAccountSettingsPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_SETTINGS}
			displayComp={UserAccountSettingsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_USER_ACCOUNT_SETTINGS]}
			displayName={'User Account Settings'}
		/>
	);
}

export function AdminGhostUserAccountPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST}
			displayComp={AdminGhostUserAccountsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST]}
			displayName={'Admin Ghost User Account'}
		/>
	);
}

export function UserAccountFinalizationPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION}
			displayComp={UserAccountFinalizationsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION]}
			displayName={'User Account Finalization'}
		/>
	);
}

export function ThirdPartyUserAccountMappingPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING}
			displayComp={ThirdPartyUserAccountMappingsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING]}
			displayName={'Third Party User Account Mapping'}
		/>
	);
}

export function PreviousEmailAddressPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS}
			displayComp={PreviousEmailAddressesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS]}
			displayName={'Previous Email Address'}
		/>
	);
}

export function PendingEmailChangePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PENDING_EMAIL_CHANGE}
			displayComp={PendingEmailChangesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PENDING_EMAIL_CHANGE]}
			displayName={'Pending Email Change'}
		/>
	);
}

export function ArchivedPendingEmailChangePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE}
			displayComp={ArchivedPendingEmailChangesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE]}
			displayName={'Archived Pending Email Change'}
		/>
	);
}

export function PasswordPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PASSWORD}
			displayComp={PasswordsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PASSWORD]}
			displayName={'Password'}
		/>
	);
}

export function ExpiredPasswordPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_EXPIRED_PASSWORD}
			displayComp={ExpiredPasswordsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_EXPIRED_PASSWORD]}
			displayName={'Expired Password'}
		/>
	);
}

export function PasswordResetPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PASSWORD_RESET}
			displayComp={PasswordResetsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PASSWORD_RESET]}
			displayName={'Password Reset'}
		/>
	);
}

export function DepositPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT}
			displayComp={DepositsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT]}
			displayName={'Deposit'}
		/>
	);
}

export function DepositInvitePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT_INVITE}
			displayComp={DepositInvitesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT_INVITE]}
			displayName={'Deposit Invite'}
		/>
	);
}

export function DepositAdjustmentPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT_ADJUSTMENT}
			displayComp={DepositAdjustmentsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT_ADJUSTMENT]}
			displayName={'Deposit Adjustment'}
		/>
	);
}

export function DepositInterestPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT_INTEREST}
			displayComp={DepositInterestsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT_INTEREST]}
			displayName={'Deposit Interest'}
		/>
	);
}

export function DepositHistoryEntryPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY}
			displayComp={DepositHistoryEntriesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY]}
			displayName={'Deposit History Entry'}
		/>
	);
}

export function DepositCloseRequestPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST}
			displayComp={DepositCloseRequestsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST]}
			displayName={'Deposit Close Request'}
		/>
	);
}

export function DepositUserStatsPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT_USER_STATS}
			displayComp={DepositUserStatsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT_USER_STATS]}
			displayName={'Deposit User Stats'}
		/>
	);
}

export function DepositBankMappingPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT_BANK_MAPPING}
			displayComp={DepositBankMappingsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT_BANK_MAPPING]}
			displayName={'deposit_bank_mapping'}
		/>
	);
}

export function DepositBulkImportPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSITS_BULK_IMPORT}
			displayComp={DepositBulkImportsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSITS_BULK_IMPORT]}
			displayName={'Deposit Bulk Import'}
		/>
	);
}

export function DepositInterestLogPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT_INTEREST_LOG}
			displayComp={DepositInterestLogsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT_INTEREST_LOG]}
			displayName={'Deposit Interest Log'}
		/>
	);
}

export function ArchivedDepositCloseRequestPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST}
			displayComp={ArchivedDepositCloseRequestsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST]}
			displayName={'Archived Deposit Close Request'}
		/>
	);
}

export function DepositWithheldFundsPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS}
			displayComp={DepositWithheldFundsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS]}
			displayName={'Deposit Withheld Funds'}
		/>
	);
}

export function PMCReportTimetablePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PMC_REPORT_TIMETABLE}
			displayComp={PmcReportTimetablesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PMC_REPORT_TIMETABLE]}
			displayName={'PMC Report Timetable'}
		/>
	);
}

export function DepositGroupPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT_GROUP}
			displayComp={DepositGroupsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT_GROUP]}
			displayName={'Deposit Group'}
		/>
	);
}

export function DepositPostCloseAdjustmentPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT}
			displayComp={DepositPostCloseAdjustmentsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT]}
			displayName={'Deposit Post Close Adjustment'}
		/>
	);
}

export function DepositUserGroupPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIT_USER_GROUP}
			displayComp={DepositUserGroupsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIT_USER_GROUP]}
			displayName={'Deposit User Group'}
		/>
	);
}

export function PropertyGroupPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PROPERTY_GROUP}
			displayComp={PropertyGroupsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PROPERTY_GROUP]}
			displayName={'Property Group'}
		/>
	);
}

export function PropertyUserGroupPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PROPERTY_USER_GROUP}
			displayComp={PropertyUserGroupsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PROPERTY_USER_GROUP]}
			displayName={'Property User Group'}
		/>
	);
}

export function DisputePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DISPUTE}
			displayComp={DisputesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DISPUTE]}
			displayName={'Dispute'}
		/>
	);
}

export function DisputeSplitPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DISPUTE_SPLIT}
			displayComp={DisputeSplitsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DISPUTE_SPLIT]}
			displayName={'Dispute Split'}
		/>
	);
}

export function DisputeInterventionRequestPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST}
			displayComp={DisputeInterventionRequestsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST]}
			displayName={'Dispute Intervention Request'}
		/>
	);
}

export function PropertyPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PROPERTY}
			displayComp={PropertiesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PROPERTY]}
			displayName={'Property'}
		/>
	);
}

export function PropertyAddressPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PROPERTY_ADDRESS}
			displayComp={PropertyAddressesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PROPERTY_ADDRESS]}
			displayName={'Property Address'}
		/>
	);
}

export function CompliancePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_COMPLIANCE}
			displayComp={CompliancesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_COMPLIANCE]}
			displayName={'Compliance'}
		/>
	);
}

export function ComplianceRulePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_COMPLIANCE_RULE}
			displayComp={ComplianceRuleTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_COMPLIANCE_RULE]}
			displayName={'Compliance Rule'}
		/>
	);
}

export function ComplianceHistoryPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_COMPLIANCE_HISTORY}
			displayComp={ComplianceHistoriesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_COMPLIANCE_HISTORY]}
			displayName={'Compliance History'}
		/>
	);
}

export function EmailTemplatePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_EMAIL_TEMPLATE}
			displayComp={EmailTemplatesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_EMAIL_TEMPLATE]}
			displayName={'Email Template'}
		/>
	);
}

export function EmailVerificationPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_EMAIL_VERIFICATION}
			displayComp={EmailVerificationsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_EMAIL_VERIFICATION]}
			displayName={'Email Verification'}
		/>
	);
}

export function EmailVerificationRecordPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD}
			displayComp={EmailVerificationRecordsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD]}
			displayName={'Email Verification Record'}
		/>
	);
}

export function EmailEventPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_EMAIL_EVENT}
			displayComp={EmailEventsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_EMAIL_EVENT]}
			displayName={'Email Event'}
		/>
	);
}

export function SentEmailPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_SENT_EMAIL}
			displayComp={SentEmailsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_SENT_EMAIL]}
			displayName={'Sent Email'}
		/>
	);
}

export function MailboxPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_MAILBOX}
			displayComp={MailboxesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_MAILBOX]}
			displayName={'Mailbox'}
		/>
	);
}

export function MailboxMetaDataPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_MAILBOX_META_DATA}
			displayComp={MailboxMetaDataTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_MAILBOX_META_DATA]}
			displayName={'Mailbox Meta Data'}
		/>
	);
}

export function MailboxMessagePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_MAILBOX_MESSAGE}
			displayComp={MailboxMessagesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_MAILBOX_MESSAGE]}
			displayName={'Mailbox Message'}
		/>
	);
}

export function PermissionEntryPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PERMISSION_ENTRY}
			displayComp={PermissionEntriesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PERMISSION_ENTRY]}
			displayName={'Permission Entry'}
		/>
	);
}

export function PermissionLogEntryPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PERMISSION_LOG_ENTRY}
			displayComp={PermissionLogEntriesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PERMISSION_LOG_ENTRY]}
			displayName={'Permission Log Entry'}
		/>
	);
}

export function PermissionsOrganizationSettingsPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS}
			displayComp={PermissionsOrganizationSettingsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS]}
			displayName={'Permissions Organization Settings'}
		/>
	);
}

export function ResourcePermissionPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_RESOURCE_PERMISSIONS}
			displayComp={ResourcePermissionsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_RESOURCE_PERMISSIONS]}
			displayName={'Resource Permissions'}
		/>
	);
}

export function OrganizationPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_ORGANIZATION}
			displayComp={OrganizationsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_ORGANIZATION]}
			displayName={'Organization'}
		/>
	);
}

export function OrganizationResourcePermissionRulePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE}
			displayComp={OrganizationResourcePermissionRulesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE]}
			displayName={'Organization Resource Permission Rule'}
		/>
	);
}

export function InvoicePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_INVOICE}
			displayComp={InvoicesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_INVOICE]}
			displayName={'Invoice'}
		/>
	);
}

export function InvoiceItemPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_INVOICE_ITEM}
			displayComp={InvoiceItemsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_INVOICE_ITEM]}
			displayName={'Invoice Item'}
		/>
	);
}

export function PaymentRequestPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PAYMENT_REQUEST}
			displayComp={PaymentRequestsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PAYMENT_REQUEST]}
			displayName={'Payment Request'}
		/>
	);
}

export function StripePaymentLogPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_STRIPE_PAYMENT_LOG}
			displayComp={StripePaymentLogsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_STRIPE_PAYMENT_LOG]}
			displayName={'Stripe Payment Log'}
		/>
	);
}

export function UserWithdrawPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_USER_WITHDRAW}
			displayComp={UserWithdrawsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_USER_WITHDRAW]}
			displayName={'User Withdraw'}
		/>
	);
}

export function PriorityACHPaymentPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PRIORITY_ACH_PAYMENT}
			displayComp={PriorityAchPaymentsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PRIORITY_ACH_PAYMENT]}
			displayName={'Priority ACH Payment'}
		/>
	);
}

export function PriorityACHRecurringPaymentPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT}
			displayComp={PriorityAchRecurringPaymentsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT]}
			displayName={'Priority ACH Payment'}
		/>
	);
}

export function LoanApplicationPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_LOAN_APPLICATION}
			displayComp={LoanApplicationsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_LOAN_APPLICATION]}
			displayName={'Loan Application'}
		/>
	);
}

export function LoanSystemInfoPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_LOAN_SYSTEM_INFO}
			displayComp={LoanSystemInfosTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_LOAN_SYSTEM_INFO]}
			displayName={'Loan System Info'}
		/>
	);
}

export function LoanPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_LOAN}
			displayComp={LoansTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_LOAN]}
			displayName={'Loan'}
		/>
	);
}

export function LoanHistoryPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_LOAN_HISTORY}
			displayComp={HistoryEntriesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_LOAN_HISTORY]}
			displayName={'Loan History'}
		/>
	);
}

export function LoanPaymentLogPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_LOAN_PAYMENT_LOG}
			displayComp={LoanPaymentLogsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_LOAN_PAYMENT_LOG]}
			displayName={'LoanPaymentLog'}
		/>
	);
}

export function StripeWebhookLogPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_STRIPE_WEBHOOK_LOG}
			displayComp={LogEntriesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_STRIPE_WEBHOOK_LOG]}
			displayName={'StripeWebhookLog'}
		/>
	);
}

export function UserAccountPaymentProviderInfoPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO}
			displayComp={InfoTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO]}
			displayName={'User Account Payment Provider Info'}
		/>
	);
}

export function SezzleOrderPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_SEZZLE_ORDER}
			displayComp={SezzleOrdersTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_SEZZLE_ORDER]}
			displayName={'Sezzle Order'}
		/>
	);
}

export function SezzleWebhookEventPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT}
			displayComp={SezzleWebhookEventsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT]}
			displayName={'Sezzle Webhook Event'}
		/>
	);
}

export function BankAccountPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_BANK_ACCOUNT}
			displayComp={BankAccountsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_BANK_ACCOUNT]}
			displayName={'Bank Account'}
		/>
	);
}

export function BankAccountHistoricalInterestRatePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE}
			displayComp={BankAccountHistoricalInterestRatesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE]}
			displayName={'Bank Account Historical Interest Rate'}
		/>
	);
}

export function BankAccountInterestPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_BANK_ACCOUNT_INTEREST}
			displayComp={BankAccountInterestsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_BANK_ACCOUNT_INTEREST]}
			displayName={'Bank Account Interest'}
		/>
	);
}

export function BankAccountBalanceRecordPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD}
			displayComp={BankAccountBalanceRecordsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD]}
			displayName={'Bank Account Balance Record'}
		/>
	);
}

export function BankTransferPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_BANK_TRANSFER}
			displayComp={BankTransfersTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_BANK_TRANSFER]}
			displayName={'Bank Transfer'}
		/>
	);
}

export function BulkFundsTransferPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_BULK_FUNDS_TRANSFER}
			displayComp={BulkFundsTransfersTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_BULK_FUNDS_TRANSFER]}
			displayName={'Bulk Funds Transfer'}
		/>
	);
}

export function FundsLockPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_FUNDS_LOCK}
			displayComp={FundsLocksTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_FUNDS_LOCK]}
			displayName={'Funds Lock'}
		/>
	);
}

export function FundsLockReleaseLogPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG}
			displayComp={FundsLockReleaseLogsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG]}
			displayName={'Funds Lock Release Log'}
		/>
	);
}

export function ReleasedFundsLockPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_RELEASED_FUNDS_LOCK}
			displayComp={ReleasedFundsLocksTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_RELEASED_FUNDS_LOCK]}
			displayName={'Released Funds Lock'}
		/>
	);
}

export function BalanceSourceTransferPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER}
			displayComp={BalanceSourceTransfersTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER]}
			displayName={'Balance Source Transfer'}
		/>
	);
}

export function CreditUserAccountLogPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG}
			displayComp={CreditUserAccountLogsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG]}
			displayName={'Credit User Account Log'}
		/>
	);
}

export function EventPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_EVENT}
			displayComp={EventsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_EVENT]}
			displayName={'Event'}
		/>
	);
}

export function EventHookPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_EVENT_HOOK}
			displayComp={EventHooksTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_EVENT_HOOK]}
			displayName={'Event Hook'}
		/>
	);
}

export function NotificationPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_NOTIFICATION}
			displayComp={NotificationsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_NOTIFICATION]}
			displayName={'Notification'}
		/>
	);
}

export function ActionItemPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_ACTION_ITEM}
			displayComp={ActionItemsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_ACTION_ITEM]}
			displayName={'Action Item'}
		/>
	);
}

export function UpdateLogPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_UPDATE_LOG_ENTRY}
			displayComp={UpdateLogsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_UPDATE_LOG_ENTRY]}
			displayName={'Update Log'}
		/>
	);
}

export function StorageFilePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_STORAGE_FILE}
			displayComp={StorageFilesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_STORAGE_FILE]}
			displayName={'Storage File'}
		/>
	);
}

export function AttachedStorageFilesPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_ATTACHED_STORAGE_FILES}
			displayComp={AttachedStorageFilesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_ATTACHED_STORAGE_FILES]}
			displayName={'Attached Storage Files'}
		/>
	);
}

export function SystemHistoryEntryPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY}
			displayComp={SystemHistoryEntriesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY]}
			displayName={'System History Entry'}
		/>
	);
}

export function SnapshotPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_SNAPSHOT}
			displayComp={SnapshotsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_SNAPSHOT]}
			displayName={'Snapshot'}
		/>
	);
}

export function IPAddressPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_IP_ADDRESS}
			displayComp={IpAddressesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_IP_ADDRESS]}
			displayName={'IP Address'}
		/>
	);
}

export function KnownIPAddressPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_KNOWN_IP_ADDRESS}
			displayComp={KnownIpAddressesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_KNOWN_IP_ADDRESS]}
			displayName={'Known IP Address'}
		/>
	);
}

export function UserAgentPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_USER_AGENT}
			displayComp={UserAgentsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_USER_AGENT]}
			displayName={'User Agent'}
		/>
	);
}

export function KnownUserAgentPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_KNOWN_USER_AGENT}
			displayComp={KnownUserAgentsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_KNOWN_USER_AGENT]}
			displayName={'Known User Agent'}
		/>
	);
}

export function SystemStatsPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_SYSTEM_STATS}
			displayComp={SystemStatsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_SYSTEM_STATS]}
			displayName={'System Stats'}
		/>
	);
}

export function ResourceNotePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_RESOURCE_NOTE}
			displayComp={ResourceNoteTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_RESOURCE_NOTE]}
			displayName={'Resource Note'}
		/>
	);
}

export function DeposifyTagPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_DEPOSIFY_TAG}
			displayComp={DeposifyTagsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_DEPOSIFY_TAG]}
			displayName={'Deposify Tag'}
		/>
	);
}

export function PermanentLinkPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_PERMANENT_LINK}
			displayComp={LinksTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_PERMANENT_LINK]}
			displayName={'Permanent Link'}
		/>
	);
}

export function OnlineUserPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_ONLINE_USER}
			displayComp={OnlineUsersTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_ONLINE_USER]}
			displayName={'Online User'}
		/>
	);
}

export function FrontendGeneralSettingsPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS}
			displayComp={FrontendGeneralSettingsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS]}
			displayName={'Frontend General Settings'}
		/>
	);
}

export function YardiScreeningWorksProXMLPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML}
			displayComp={YardiScreeningWorksProXmlTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML]}
			displayName={'Yardi Screening Works Pro XML'}
		/>
	);
}

export function YardiVoyagerXMLPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_XML}
			displayComp={YardiVoyagerXmlTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_XML]}
			displayName={'Yardi Voyager XML'}
		/>
	);
}

export function YardiVoyagerTransactionPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION}
			displayComp={YardiVoyagerTransactionsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION]}
			displayName={'Yardi Voyager Transaction'}
		/>
	);
}

export function YardiVoyagerResidentPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT}
			displayComp={YardiVoyagerResidentsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT]}
			displayName={'Yardi Voyager Resident'}
		/>
	);
}

export function YardiVoyagerResidentCustomColumnPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN}
			displayComp={YardiVoyagerResidentCustomColumnsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN]}
			displayName={'Yardi Voyager Resident Custom Column'}
		/>
	);
}

export function YardiVoyagerPropertyUnitPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT}
			displayComp={YardiVoyagerPropertyUnitsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT]}
			displayName={'Yardi Voyager Property Unit'}
		/>
	);
}

export function YardiVoyagerPropertyPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY}
			displayComp={YardiVoyagerPropertiesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY]}
			displayName={'Yardi Voyager Property'}
		/>
	);
}

export function YardiVoyagerPMCServiceInterfaceVersionPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION}
			displayComp={YardiVoyagerPmcServiceInterfaceVersionsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION]}
			displayName={'Yardi Voyager PMC Service Interface Version'}
		/>
	);
}

export function YardiVoyagerPMCPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC}
			displayComp={YardiVoyagerPmcsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_PMC]}
			displayName={'Yardi Voyager PMC'}
		/>
	);
}

export function YardiVoyagerPMCCredentialsPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS}
			displayComp={YardiVoyagerPmcCredentialsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS]}
			displayName={'Yardi Voyager PMC Credentials'}
		/>
	);
}

export function YardiVoyagerPetPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PET}
			displayComp={YardiVoyagerPetsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_PET]}
			displayName={'Yardi Voyager Pet'}
		/>
	);
}

export function YardiVoyagerILSGuestCardEventPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT}
			displayComp={YardiVoyagerIlsGuestCardEventsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT]}
			displayName={'Yardi Voyager ILS Guest Card Event'}
		/>
	);
}

export function YardiVoyagerChargePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_CHARGE}
			displayComp={YardiVoyagerChargesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE]}
			displayName={'Yardi Voyager Charge'}
		/>
	);
}

export function YardiVoyagerChargeCodePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE}
			displayComp={YardiVoyagerChargeCodesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE]}
			displayName={'Yardi Voyager Charge Code'}
		/>
	);
}

export function YardiVoyagerDepositCreateIntentPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT}
			displayComp={YardiVoyagerDepositCreateIntentsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT]}
			displayName={'Yardi Voyager Deposit Intent'}
		/>
	);
}

export function YardiVoyagerDepositCloseIntentPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT}
			displayComp={YardiVoyagerDepositCloseIntentsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT]}
			displayName={'Yardi Voyager Deposit Close Intent'}
		/>
	);
}

export function YardiVoyagerDepositWithholdIntentPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT}
			displayComp={YardiVoyagerDepositWithholdIntentsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT]}
			displayName={'Yardi Voyager Deposit Withhold Intent'}
		/>
	);
}

export function YardiVoyagerEventPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_EVENT}
			displayComp={YardiVoyagerEventsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_EVENT]}
			displayName={'Yardi Voyager Event'}
		/>
	);
}

export function YardiVoyagerFlexDepositIntentPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT}
			displayComp={YardiVoyagerFlexDepositIntentsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT]}
			displayName={'Yardi Voyager Flex Deposit Intent'}
		/>
	);
}

export function YardiVoyagerPhonePage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PHONE}
			displayComp={YardiVoyagerPhonesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_PHONE]}
			displayName={'Yardi Voyager Phone'}
		/>
	);
}

export function YardiVoyagerOtherOccupantPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT}
			displayComp={YardiVoyagerOtherOccupantsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT]}
			displayName={'Yardi Voyager Other Occupant'}
		/>
	);
}

export function YardiVoyagerPMCCustomColumnSettingsPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS}
			displayComp={YardiVoyagerPmcCustomColumnSettingsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS]}
			displayName={'Yardi Voyager PMC Custom Column Settings'}
		/>
	);
}

export function YardiVoyagerPMCStatsPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS}
			displayComp={YardiVoyagerPmcStatsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS]}
			displayName={'Yardi Voyager PMC Stats'}
		/>
	);
}

export function YardiVoyagerPMCStatsCollectorPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR}
			displayComp={YardiVoyagerPmcStatsCollectorsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR]}
			displayName={'Yardi Voyager PMC Stats Collector'}
		/>
	);
}

export function YardiVoyagerActiveScanLogEntryPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY}
			displayComp={YardiVoyagerActiveScanLogEntriesTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY]}
			displayName={'Yardi Voyager Active Scan Log Entry'}
		/>
	);
}

export function YardiVoyagerSystemSettingsPage(props) {
	return (
		<GenericResourceTablePage
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS}
			displayComp={YardiVoyagerSystemSettingsTable}
			icon={RESOURCE_ICONS_DICT[RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS]}
			displayName={'Yardi Voyager System Settings'}
		/>
	);
}

